/*
 * @Author: Chao Yang
 * @Date: 2020-01-02 15:38:26
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-02 15:40:20
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdSkeletonComponent } from './ad-skeleton.component';

@NgModule({
  declarations: [AdSkeletonComponent],
  imports: [CommonModule],
  exports: [AdSkeletonComponent]
})
export class AdSkeletonModule {}
export { AdSkeletonComponent };
